<template>
  <div>
    <el-dialog
      title="获取通知地址"
      center
      :visible="true"
      @before-close="onClose"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
    >
      <el-form ref="form" :model="form" label-width="140px" size="mini">
        <el-form-item label="获取方式：" prop="">
          <el-select
            style="width: 150px"
            v-model="form.valueType"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in availableStyles"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="值：" prop="">
          <el-input
            placeholder="请正确填写一个邮箱地址或者手机号"
            v-model="form.value"
            style="width: 350px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="submit()" style="margin-left: 30px"
          >开始获取</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "GetUserIdDialog";

export default {
  data() {
    return {
      form: {
        valueType: "",
        value: "",
        addressType: "",
        app: "",
      },
      availableStyles: ["邮箱"],
    };
  },
  components: {},

  async created() {
    let value = this.$dialogutil.getData(DialogName);
    this.form.addressType = value.addressType;
    this.form.app = value.app;
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      this.getUserId();
    },

    /**
     * 修改密码
     */
    async getUserId() {
      if (this.form.valueType.trim().length == 0) {
        this.$message({
          message: "请选择方式",
          type: "fail",
        });
        return;
      }
      if (this.form.value.trim().length == 0) {
        this.$message({
          message: "方式对应的值不能为空",
          type: "fail",
        });
        return;
      }

      try {
        // 弹确认框
        await this.$confirm(`确认填写无误？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/corpflow/getCorpUserId`,
            this.form,
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "获取成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(resData.data.userId);
      } catch (e) {}
    },

    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
    onCloseWhitParam(param) {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName, param);
    },
  },
};
</script>

<style scoped>
.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}
</style>